import React from 'react'
import { Rating } from '@smastrom/react-rating'
import './ReactRating.css' // Import the default styles from library, moved here for include in build

import { RatingWrapper } from './style'

const RatingComponent = ({ title, value, total }) => {
  const CircleDrawing = (
    <svg height='100' width='100' xmlns='http://www.w3.org/2000/svg'>
      <circle r='45' cx='50' cy='50' />
    </svg>
  )

  const customStyles = {
    itemShapes: CircleDrawing,
    activeFillColor: '#618b8e',
    inactiveFillColor: '#ceebed',
  }

  return (
    <RatingWrapper>
      {title}:&nbsp;
      <Rating
        style={{ maxWidth: 90 }}
        value={value}
        items={total}
        readOnly
        itemStyles={customStyles}
        radius='small'
        spaceBetween='small'
        spaceInside='small'
      />
      &nbsp;
      {value}&nbsp;/&nbsp;{total}
    </RatingWrapper>
  )
}

export default RatingComponent
